import { useCallback, useState } from 'react'
import { useMutation, useQuery, useQueryCache } from 'react-query'
import { get } from 'lodash'

const useApiMutation = ({
    id,
    onSuccess = () => {},
    onError = () => {},

    onCreate = () => {},
    onRetrieve = () => {},
    onUpdate = () => {},
    defaultData = {},
}) => {
    const [ data, setData ] = useState(defaultData)
    const onFetchSuccess = useCallback(data => setData(data), [setData])
    const { isLoading } = useQuery(id, onRetrieve, { enabled: Boolean(id), onSuccess: onFetchSuccess })

    const [ create, { isLoading: isCreating }] = useMutation(onCreate, { onSuccess, onError })
    const [ update, { isLoading: isUpdating }] = useMutation(onUpdate, { onSuccess, onError })

    //  Saving
    const save = useCallback(() => {
        console.log('saving:', data)
        if (get(data, 'id')) {
            update(data)
        } else {
            create(data)
        }
    }, [data, update, create])


    return {
        isBusy: isLoading || isCreating || isUpdating,
        isLoading,
        isSaving: isCreating || isUpdating,
        save,
        data,
        setData
    }
}

export default useApiMutation